<template>
    <div>
      <v-dialog persistent v-model="showEditOnvifDiscoveryVersionDialog" width="40vw">
        <v-card :loading="loading">
          <v-form
            lazy-validation
            v-model="form"
            ref="newOnvifDiscoveryVersionForm"
            :disable="loading"
          >
            <v-card-title>
              <span class="text-h6 mr-2">Edit v{{ onvifDiscoveryVersion.version }}</span>
              <v-spacer></v-spacer>
              <v-btn @click="close" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="onvifDiscoveryVersionPayload.version"
                    :rules="[rules.required]"
                    label="*Onvif Discovery Version"
                    color="deep-purple"
                    outlined
                    hide-details="auto"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions class="pr-4 pb-4">
              <v-spacer></v-spacer>
              <v-btn
                @click="editOnvifDiscoveryVersion()"
                :disabled="!form || loading"
                color="primary"
              >
                SAVE
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import Swal from 'sweetalert2'
import { apiService } from '../../service/api.service'

export default {
  props: {
    showEditOnvifDiscoveryVersionDialog: { type: Boolean, default: false },
    onvifDiscoveryVersion: {
      type: Object,
      default: () => null
    }
  },

  data: () => ({
    loading: false,
    form: true,
    onvifDiscoveryVersionPayload: {
      onvif_discovery_id: null,
      version: ''
    },
    rules: {
      required: (value) => !!value || 'Required.'
    }
  }),

  created () {
    this.copyOnvifDiscoveryVersion()
  },

  methods: {
    async editOnvifDiscoveryVersion () {
      if (this.$refs.newOnvifDiscoveryVersionForm.validate()) {
        this.loading = true
        await apiService
          .put('admin/onvif_discovery_version', this.onvifDiscoveryVersionPayload)
          .then((res) => {
            this.loading = false

            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Onvif discovery version updated successfully'
            })
            this.$emit('fetchOnvifDiscoveryVersion')
            this.close()
          })
          .catch((err) => {
            this.loading = false
            Swal.fire({
              icon: 'error',
              title: 'Failed edit onvif discovery version',
              text: err.response.data.message
            })
          })
      }
    },
    copyOnvifDiscoveryVersion () {
      this.onvifDiscoveryVersionPayload.onvif_discovery_id = this.onvifDiscoveryVersion.id
      this.onvifDiscoveryVersionPayload.version = this.onvifDiscoveryVersion.version
    },

    close () {
      this.$emit('closeEditOnvifDiscoveryVersionDialog')
    }
  }
}
</script>

    <style>
  </style>
